// auth module boundary — PD-1 surface.
export { authApi } from "./api/authApi";
export { AuthApiError } from "./api/errors";
export type { AuthErrorBody } from "./api/errors";
export type {
  AuthOrganization,
  AuthUser,
  AuthUserRole,
  ChangePasswordResponse,
  LoginResponse,
  PasswordResetConfirmRequest,
  PasswordResetConfirmResponse,
  PasswordResetRequestRequest,
  PasswordResetRequestResponse,
  RefreshResponse,
} from "./api/types";
export { AuthProvider, useAuth, useUser } from "./session/AuthProvider";
export { RequireAuth } from "./session/RequireAuth";
export { PasswordRequirements } from "./components/PasswordRequirements";
export { ChangePasswordForm } from "./components/ChangePasswordForm";
export { AccountSettingsScreen } from "./components/AccountSettingsScreen";
export type { ChangePasswordFormProps } from "./components/ChangePasswordForm";
export { MIN_PASSWORD_LENGTH } from "./lib/passwordPolicy";
export type { PasswordIdentity } from "./lib/passwordPolicy";
